// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as HomeBannerTextV2ModuleScss from "../styles/HomeBannerTextV2.module.scss";

var styles = HomeBannerTextV2ModuleScss;

function HomeBannerTextCmpV2(Props) {
  var title = Props.title;
  var description = Props.description;
  return React.createElement("div", {
              className: styles["banner-wrapper"]
            }, React.createElement("h1", {
                  className: styles["banner-subtext"]
                }, description), React.createElement("h1", {
                  className: styles["banner-text"]
                }, title));
}

var make = HomeBannerTextCmpV2;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
